import React, { Component } from "react";
import Button from "../../../button-classic/button-classic";
import InputText from "../../../../common/components/input-text/input-text";
import Select from "react-select";
import { debounce } from "../../../../utils/index.js";
import "../../../route_code/route_code.less";

class AddToleranceMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedMaterial: this.props.editData
        ? { label: `${this.props.editData.material_code} - ${this.props.editData.material_name}`, value: this.props.editData.material_code, material_code: this.props.editData.material_code, materialName: this.props.editData.material_name }
        : null,
      data: {
        charged_weight: this.props.editData ? this.props.editData.charged_weight : "",
        empty_bag_weight: this.props.editData ? this.props.editData.empty_bag_weight : "",
        max_tolerance: this.props.editData ? this.props.editData.max_tolerance : 40,
        upper_tolerance: this.props.editData ? this.props.editData.upper_tolerance : "",
        company_id: this.props.editData ? this.props.editData.company_id : this.props.companyId,
        branch_id: this.props.editData ? this.props.editData.branch_id : this.props.branchId,
      },
    };
    this.debouncedGetMaterialData = debounce(this.props.getMaterialData, 500);
  }

  onChangeHandler = (value, id) => {
    let { data } = this.state;
    data[id] = value;
    this.setState({ data });
  };

  onDecimalChange = (value, id) => {
    if (value === "" || value === "0") {
      return this.onChangeHandler(value, id);
    }
    const regEx = /^[+]?([0-9][0-9]*(?:[.][0-9]*)?|0*[.][0-9]+)$/;
    if (regEx.test(value)) {
      this.onChangeHandler(value, id);
    }
  };

  onMaterialSelect = (option) => {
    this.setState({ selectedMaterial: option });
  };

  isFormValid = () => {
    const { data, selectedMaterial } = this.state;
    return selectedMaterial && data.charged_weight && data.empty_bag_weight && data.max_tolerance && data.upper_tolerance;
  };

  toDouble = (val) => parseFloat(val);

  onSave = () => {
    const { data, selectedMaterial } = this.state;
    this.props.onSave({
      ...data,
      charged_weight: this.toDouble(data.charged_weight),
      empty_bag_weight: this.toDouble(data.empty_bag_weight),
      max_tolerance: this.toDouble(data.max_tolerance),
      upper_tolerance: this.toDouble(data.upper_tolerance),
      material_code: selectedMaterial && selectedMaterial.material_code,
      material_name: selectedMaterial && selectedMaterial.materialName,
    });
  };

  onUpdate = () => {
    const { data, selectedMaterial } = this.state;
    this.props.onUpdate({
      ...data,
      charged_weight: this.toDouble(data.charged_weight),
      empty_bag_weight: this.toDouble(data.empty_bag_weight),
      max_tolerance: this.toDouble(data.max_tolerance),
      upper_tolerance: this.toDouble(data.upper_tolerance),
      material_code: selectedMaterial && selectedMaterial.material_code,
      material_name: selectedMaterial && selectedMaterial.materialName,
    });
  };

  render() {
    const { data, selectedMaterial } = this.state;
    const { materialOptions } = this.props;
    const disabled = !this.isFormValid();

    return (
      <div className="route_code_detail">
        <div onClick={this.props.toggleAdd} className="overlay"></div>
        <div id="modal" className="modal-popup">
          <div className="pop-heading">
            {`${this.props.editData ? "Edit" : "Add"} Tolerance Master`}
          </div>
          <div className="route-detail">
            <div className="details-section" style={{ display: "flex", gap: "30px" }}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div className="label">Material <span className="error-color">*</span></div>
                <Select
                  className="selectpack"
                  options={materialOptions}
                  value={selectedMaterial}
                  onChange={this.onMaterialSelect}
                  placeholder="Search material..."
                  isSearchable={true}
                  onInputChange={(value) => {
                    if (value.length > 2) {
                      this.debouncedGetMaterialData(value);
                    }
                    return value;
                  }}
                  styles={{ menu: (provided) => ({ ...provided, zIndex: 99999 }) }}
                />
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <InputText
                  placeholder=""
                  id="charged_weight"
                  label="Charged Weight"
                  changeHandler={(value) => this.onDecimalChange(value, "charged_weight")}
                  value={data.charged_weight}
                  required={true}
                />
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <InputText
                  placeholder=""
                  id="empty_bag_weight"
                  label="EmptyBag Weight"
                  changeHandler={(value) => this.onDecimalChange(value, "empty_bag_weight")}
                  value={data.empty_bag_weight}
                  required={true}
                />
              </div>
            </div>
            <div className="details-section" style={{ display: "flex", gap: "30px", marginTop: "20px" }}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <InputText
                  placeholder=""
                  id="max_tolerance"
                  label="Max Tolerance"
                  changeHandler={(value) => this.onDecimalChange(value, "max_tolerance")}
                  value={data.max_tolerance}
                  required={true}
                />
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <InputText
                  placeholder=""
                  id="upper_tolerance"
                  label="Upper Tolerance"
                  changeHandler={(value) => this.onDecimalChange(value, "upper_tolerance")}
                  value={data.upper_tolerance}
                  required={true}
                />
              </div>
            </div>

            <div className="button_route" style={{ marginTop: "50px" }}>
              <Button value="Cancel" click={this.props.toggleAdd} />
              {!this.props.editData ? (
                <Button value="Save" click={this.onSave} disabled={disabled} />
              ) : (
                <Button value="Update" click={this.onUpdate} disabled={disabled} />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddToleranceMaster;
